import floorPlanTab from "./grundriss-grau.png";
import floorPlanExamp from "./grundrisse-beispiele.png";
import individualExample2 from "./individueller-grundriss-beige.png";
import individualExample from "./individueller-grundriss-grau.png";
import measurementVW from "./pkw-mit-grundriss-schmiede-logo.png";
import salesOptimizedFloorPlan from "./verkaufsoptimierter-grundriss-mit-vermessung.png";
import salzesOptExamp from "./verkaufsoptimierter-grundriss.png";
import sizedFloorPlanExample from "./vorlagen-bemaßte-grundrisse.png";
import livingSpaceCalcExamp from "./wohnflaechenberechnung-beispiel.png";
import letterHeadMockUp from "./wohnflaechenberechnung.jpg";

export {
  floorPlanExamp,
  floorPlanTab,
  individualExample,
  individualExample2,
  letterHeadMockUp,
  livingSpaceCalcExamp,
  measurementVW,
  salesOptimizedFloorPlan,
  salzesOptExamp,
  sizedFloorPlanExample,
};
